import { Button, Drawer, Layout } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router'

import CartList from '@/home/src/pages/ShopCart/components/CartList'
import Coupon from '@/home/src/pages/ShopCart/components/Coupon'
import { CartReturnType } from '@api/home/shopCart/types'
import useCoupon from '@api/home/shopCart/useCoupon'
import { routesPath } from '@api/home/utils'
import { Flex, Icon, Switch, Text } from '@ui-pc'
import { loTrack } from '@utils'
import { Knife, Type } from '@utils/tool'
import winPixel from '@utils/winPixel'

import { Discount } from '../StatisticalPanel'
import { showEstPoup } from './ShopEmty'

const { Content } = Layout

type Props = {
  title: string
  open: boolean
  setOpen: Function
  shopListTotalInfo: Omit<CartReturnType, 'blockList'>
  shopList: CartReturnType['blockList'][0]
  isEmpty: boolean
}

/**
 * side cartlist
 */
export default function Index(props: Props) {
  const { title, open, setOpen, shopList, isEmpty, shopListTotalInfo } = props

  const navigate = useNavigate()

  const [currentCoupon] = Knife.map(shopListTotalInfo.addCouponList)

  const isUsedCoupon = !Type.isNever(currentCoupon)

  const [zero] = shopListTotalInfo?.availableCoupons || []

  const handler = useCoupon({
    shopListTotalInfo,
    onChange() {
      ref.current.refetch()
    }
  })

  const ref = React.useRef<{ refetch: Function }>()

  return (
    <Drawer
      title={
        <Text size={18} strong>
          {shopListTotalInfo?.itemNumTotal > 0
            ? `My Cart (${shopListTotalInfo?.itemNumTotal} item${
                Number(shopListTotalInfo?.itemNumTotal) > 1 ? 's' : ''
              })`
            : `My Cart`}
        </Text>
      }
      placement="right"
      width={480}
      open={open}
      onClose={() => setOpen(false)}
      className="view-cart"
      closeIcon={<i className="iconfont icon-close common-drawer-close" />}
      children={
        <Layout style={{ background: '#fff' }}>
          <div
            style={{
              position: 'sticky',
              top: '-5px',
              zIndex: 1,
              width: '100%',
              background: '#fff',
              paddingInline: 'none'
            }}>
            <Flex
              className="padding15"
              justify={'space-between'}
              alignItems="center"
              padding={[8, 24]}>
              <span className="cart-drawer-summary">Cart Summary</span>
              <a
                className="cart-top-text"
                onClick={() => {
                  setOpen(false)
                  loTrack('M_Popup Cart_View Cart')
                  navigate(routesPath.cart)
                }}>
                {'View Cart Details'}
                <Icon customSrc="icon-right" size={14} />
              </a>
            </Flex>
          </div>
          <Content className="padding24 sidebar-content">
            <CartList
              handle={ref}
              onJump={() => {
                setOpen(false)
              }}
            />
          </Content>
          <Switch either={!Type.isEmpty(shopList?.productList)}>
            <div className="sidebar-bottom">
              {/* <Flex
                className="free-shipping"
                alignItems="center"
                colGap={4}
                padding={[10, 24]}>
                <Icon
                  size={20}
                  customSrc="icon-a-FreeShipping"
                  className="free-shipping-text free-shipping-icon"
                />
                <span className="free-shipping-text">Free Shipping !</span>
              </Flex> */}
              <div className="sidebar-item-flex sidebar-sub-title">
                <span className="">Subtotal</span>
                <span className="sidebar-item-title sidebar-item-line">
                  {shopListTotalInfo.totalMarketPrice}
                </span>
              </div>
              <div className="sidebar-item-flex">
                <Discount shopListTotalInfo={shopListTotalInfo} />
              </div>

              {/* <div className="sidebar-item-flex sidebar-border">
                <span className="sidebar-item-title">Discount</span>
                <span className="sidebar-item-title sidebar-red">
                  {shopListTotalInfo.promoDiscount
                    ? `-${shopListTotalInfo.promoDiscount}`
                    : '$0'}
                </span>
              </div> */}
              <div className="sidebar-item-flex sidebar-subtotal">
                <span className="sidebar-item-title">{''}</span>
                <span
                  className="sidebar-item-title"
                  style={{ fontWeight: 600 }}>
                  {shopListTotalInfo.subtotal}
                </span>
              </div>
              <div
                className="sidebar-item-flex sidebar-coupon"
                onClick={() => {
                  handler.setOpen(true)
                  loTrack('Drawer_Coupon')
                }}>
                <span className="">Apply Coupon</span>
                <div className="sidebar-item-title sidebar-coupon-icon">
                  <Switch either={!!shopListTotalInfo?.appleCouponDesc}>
                    <span className={'coupon-savings'}>
                      {shopListTotalInfo?.appleCouponDesc}
                    </span>
                  </Switch>

                  {/* <Switch either={isUsedCoupon}>
                    <span className={isUsedCoupon ? 'coupon-savings' : ''}>
                      - {shopListTotalInfo.couponDiscount}
                    </span>
                    <Switch
                      either={
                        !Type.isEmpty(shopListTotalInfo?.availableCoupons)
                      }>
                      <span className={'coupon-savings'}>
                        Save extra {zero?.discount} with coupons
                      </span>
                    </Switch>
                  </Switch> */}
                  <i className="iconfont icon-m_ic_jiantou coupon-savings"></i>
                </div>
              </div>
              <Switch either={shopListTotalInfo?.showShippingFee}>
                <div className="sidebar-item-flex">
                  <span className="">Shipping Fee</span>
                  <span className="sidebar-item-title">
                    {shopListTotalInfo?.formatShippingFee || '$0'}
                  </span>
                </div>
              </Switch>
              <Switch either={!Type.isEmpty(shopListTotalInfo?.taxInfo)}>
                <>
                  <div className="sidebar-item-flex" style={{ paddingTop: 24 }}>
                    <span
                      className=""
                      onClick={() => {
                        showEstPoup()
                      }}>
                      Est. Tax
                      <Icon
                        customSrc="icon-pc_wenhao est-question"
                        style={{ color: '#999999', cursor: 'pointer' }}
                      />
                    </span>
                    <span className="sidebar-item-title">
                      {shopListTotalInfo?.taxInfo?.taxTotalFormat}
                    </span>
                  </div>
                  <Flex padding={[0, 24]}>
                    <p style={{ fontSize: 12 }}>
                      {shopListTotalInfo?.taxInfo?.taxDesc}
                    </p>
                  </Flex>
                </>
              </Switch>
              <Flex
                padding={[10, 24, 10, 20]}
                justify="space-between"
                alignItems="center"
                height="80"
                className="side-cart-bottom">
                <div className="side-total-box">
                  <span className="side-total-text">
                    {!Type.isEmpty(shopListTotalInfo?.taxInfo) && 'Est. '}Total:{' '}
                    {shopListTotalInfo.grandTotal}
                  </span>
                  {shopListTotalInfo.totalDiscount ? (
                    <span className="side-total-save">
                      Savings: {shopListTotalInfo.totalDiscount}
                    </span>
                  ) : null}
                </div>
                <Button
                  block
                  style={{ width: 180, height: 48 }}
                  size="large"
                  type="primary"
                  disabled={isEmpty}
                  onClick={() => {
                    winPixel.beginCheckout(
                      Number(shopList?.orderTotal),
                      shopList?.productList,
                      [
                        'AW-557240052/Jy8DCNrznOoYEPSd24kC',
                        'AW-11323451663/4lVSCLeVq9wYEI_SuJcq',
                        'AW-11327320617/b2DNCNn9qPIYEKnkpJkq'
                      ],
                      currentCoupon
                    )
                    navigate(routesPath.checkout)
                    loTrack('Drawer_Checkout')
                  }}>
                  <Text size={18} color="#FFFFFF">
                    Checkout Now
                  </Text>
                </Button>
              </Flex>
            </div>
          </Switch>
          <Coupon {...handler} />
          {handler.CouponTips}
        </Layout>
      }
      closable={true}
    />
  )
}
